import { defineMessages } from 'react-intl';

export default defineMessages({
    // Old changes in modules-react/gw-platform-translation/platform.messages.js
    /* Common Inputs */
    mlBlank: {
        id: 'ml.platform.inputs.common.Blank Space',
        defaultMessage: ' '
    },
    mlFirstName: {
        id: 'ml.platform.inputs.contact-details.First Name',
        defaultMessage: 'First Name'
    },
    mlMiddleName: {
        id: 'ml.platform.inputs.contact-details.Middle Name',
        defaultMessage: 'Middle Name'
    },
    mlLastName: {
        id: 'ml.platform.inputs.contact-details.Last Name',
        defaultMessage: 'Last Name'
    },
    mlName: {
        id: 'ml.platform.inputs.contact-details.Name',
        defaultMessage: 'Name'
    },
    mlSuffix: {
        id: 'ml.platform.inputs.contact-details.Suffix',
        defaultMessage: 'Suffix'
    },
    mlAge: {
        id: 'ml.platform.inputs.contact-details.Age',
        defaultMessage: 'Age'
    },
    mlAgeFirstLicensed: {
        id: 'ml.platform.inputs.contact-details.Age First Licensed',
        defaultMessage: 'Age First Licensed'
    },
    mlStateLicensed: {
        id: 'ml.platform.inputs.contact-details.State Licensed',
        defaultMessage: 'State Licensed'
    },
    mlRelationshipToInsured: {
        id: 'ml.platform.inputs.contact-details.Relationship to Insured',
        defaultMessage: 'Relationship to Insured'
    },
    mlMaritalStatus: {
        id: 'ml.platform.inputs.contact-details.Marital Status',
        defaultMessage: 'Marital Status'
    },
    mlDateOfBirth: {
        id: 'ml.platform.inputs.contact-details.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    mlGender: {
        id: 'ml.platform.inputs.contact-details.Gender',
        defaultMessage: 'Gender'
    },
    mlOccupation: {
        id: 'ml.platform.inputs.contact-details.Occupation',
        defaultMessage: 'Occupation'
    },
    mlSpouse: {
        id: 'ml.platform.inputs.contact-details.Spouse',
        defaultMessage: 'Spouse'
    },
    mlStreetAddress: {
        id: 'ml.platform.inputs.address-details.Street address',
        defaultMessage: 'Street address'
    },
    mlAddress: {
        id: 'ml.platform.inputs.address-details.Address',
        defaultMessage: 'Address'
    },
    mlStreetAddressNoPOBoxes: {
        id: 'ml.platform.inputs.address-details.Street Address (No P.O. boxes)',
        defaultMessage: 'Street Address (No P.O. boxes)'
    },
    mlCountry: {
        id: 'ml.platform.inputs.address-details.Country',
        defaultMessage: 'Country'
    },
    mlAccidentState: {
        id: 'ml.platform.inputs.address-details.Accident State',
        defaultMessage: 'Accident State'
    },
    mlAptUnit: {
        id: 'ml.platform.inputs.address-details.Apt/Unit #',
        defaultMessage: 'Apt/Unit #'
    },
    // common input help text
    mlWhyDoYpuNeedThis: {
        id: 'ml.platform.inputs.helptext.Why do you need this?',
        defaultMessage: 'Why do you need this?'
    },
    mlWhatDoesItMean: {
        id: 'ml.platform.inputs.helptext.What does this mean?',
        defaultMessage: 'What does this mean?'
    },
    mlWhatIfIDontHaveAUSLicence: {
        id: 'ml.platform.inputs.helptext.What if I don\'t have a US license?',
        defaultMessage: 'What if I don\'t have a US license?'
    },
    mlWhyDoYouNeedMyOccupation: {
        id: 'ml.platform.inputs.helptext.Why do you need my occupation?',
        defaultMessage: 'Why do you need my occupation?'
    },
    // common input options
    mlYes: {
        id: 'ml.platform.inputs.Yes',
        defaultMessage: 'Yes'
    },
    mlNo: {
        id: 'ml.platform.inputs.No',
        defaultMessage: 'No'
    },
    // common actions
    mlContinue: {
        id: 'ml.platform.actions.Continue',
        defaultMessage: 'Continue'
    },
    mlDelete: {
        id: 'ml.platform.actions.Delete',
        defaultMessage: 'DELETE'
    },
    mlNext: {
        id: 'ml.platform.actions.Next',
        defaultMessage: 'Next'
    },
    mlSave: {
        id: 'ml.platform.actions.Save',
        defaultMessage: 'Save'
    },
    mlCancel: {
        id: 'ml.platform.actions.Cancel',
        defaultMessage: 'Cancel'
    },
    mlSubmit: {
        id: 'ml.platform.actions.Submit',
        defaultMessage: 'Submit'
    },
    mlReturnToQuote: {
        id: 'ml.platform.actions.ReturnToQuote',
        defaultMessage: 'Return to Quote'
    },
    mlDropdownSelectPlaceholder: {
        id: 'jutro-components.widgets.inputs.DropdownSelectField.placeholder',
        defaultMessage: 'Select'
    },
    mlDate: {
        id: 'ml.platform.inputs.Date',
        defaultMessage: 'Date'
    },
    OneMomentPlease: {
        id: 'ml.platform.dialog.One Moment Please...',
        defaultMessage: 'One Moment Please...'
    },
    checkAvailability: {
        id: 'ml.platform.dialog.Checking if a quote can be provided for that location',
        defaultMessage: 'Checking if a quote can be provided for that location'
    },
    checkPeriodStartDateChanged: {
        id: 'ml.platform.dialog.Checking if coverage is available for that date',
        defaultMessage: 'Checking if coverage is available for that date.'
    },
    createSubmission: {
        id: 'ml.platform.dialog.Creating a new quote submission...',
        defaultMessage: 'Creating a new quote submission...'
    },
    saveSubmission: {
        id: 'ml.platform.dialog.Saving quote submission details...',
        defaultMessage: 'Saving quote submission details...'
    },
    settingThingsUp: {
        id: 'ml.platform.dialog.Just setting things up to create your personalized quote...',
        defaultMessage: 'Just setting things up to create your personalized quote...'
    },
    saveSubmissionAndSyncAccount: {
        id: 'ml.platform.dialog.Synchronizing Account...',
        defaultMessage: 'Synchronizing Account...'
    },
    saveAndQuoteSubmission: {
        id: 'ml.platform.dialog.Calculating Quote...',
        defaultMessage: 'Calculating Quote...'
    },
    bindSubmission: {
        id: 'ml.platform.dialog.Processing Payment...',
        defaultMessage: 'Processing Payment...'
    },
    processingOperation: {
        id: 'ml.platform.dialog.Processing operation...',
        defaultMessage: 'Processing operation...'
    },
    loadingMakes: {
        id: 'ml.platform.dialog.Loading makes...',
        defaultMessage: 'Loading makes...'
    },
    loadingModels: {
        id: 'ml.platform.dialog.Loading models...',
        defaultMessage: 'Loading models...'
    },
    loadingTrims: {
        id: 'ml.platform.dialog.Loading trims...',
        defaultMessage: 'Loading trims...'
    },
    loading: {
        id: 'ml.platform.dialog.Loading...',
        defaultMessage: 'Loading...'
    },
    syncing: {
        id: 'ml.platform.dialog.Syncing...',
        defaultMessage: 'Syncing...'
    },
    waiting: {
        id: 'ml.platform.dialog.Waiting...',
        defaultMessage: 'Waiting...'
    },
    creatingCustomQuotes:{
        id: 'ml.platform.dialog.Creating custom quotes...',
        defaultMessage: 'Creating custom quotes...'
    },
    emailingQuote:{
        id: 'ml.platform.dialog.Emailing Quote...',
        defaultMessage: 'Emailing Quote...'
    },
    saving:{
        id: 'ml.platform.dialog.Saving...',
        defaultMessage: 'Saving...'
    },
    downloadingDocument:{
        id: 'ml.platform.dialog.Downloading document...',
        defaultMessage: 'Downloading document...'
    },
    synchronizingQuote:{
        id: 'ml.platform.dialog.Synchronizing quote...',
        defaultMessage: 'Synchronizing quote...'
    },
    updatingSubmission:{
        id: 'ml.platform.dialog.Updating submission...',
        defaultMessage: 'Updating submission...'
    },
    syncingQuestions:{
        id: 'ml.platform.dialog.Syncing questions...',
        defaultMessage: 'Syncing questions...'
    },
    retrievingHomeDetails:{
        id: 'ml.platform.dialog.Retrieving home details...',
        defaultMessage: 'Retrieving home details...'
    },
    searchingGroupAffiliationInformation:{
        id: 'ml.platform.dialog.Searching group affiliation information',
        defaultMessage: 'Searching group affiliation information'
    },
    retrievingGroupAffiliationInformation:{
        id: 'ml.platform.dialog.Retrieving group affiliation information',
        defaultMessage: 'Retrieving group affiliation information'
    },
    generatingQuoteProposal:{
        id: 'ml.platform.dialog.Generating Quote Proposal',
        defaultMessage: 'Generating Quote Proposal'
    },
    getPolicyDetails:{
        id: 'ml.platform.dialog.Get Policy Change Details',
        defaultMessage: 'Get Policy Change Details'
    },
    syncingDiscounts:{
        id: 'ml.platform.dialog.Syncing discounts...',
        defaultMessage: 'Syncing discounts...'
    },
    checkingEligibility:{
        id: 'ml.platform.dialog.Checking eligibility',
        defaultMessage: 'Checking eligibility'
    },
    checkingProducerCodeEligibility:{
        id: 'ml.platform.dialog.Checking producer code eligibility...',
        defaultMessage: 'Checking producer code eligibility...'
    },
    updatingQuote:{
        id: 'ml.platform.dialog.Updating quote...',
        defaultMessage: 'Updating quote...'
    },
    retrievingDraftSubmission:{
        id: 'ml.platform.dialog.Retrieving draft submission...',
        defaultMessage: 'Retrieving draft submission...'
    },
    retrievingQuotedSubmission:{
        id: 'ml.platform.dialog.Retrieving quoted submission...',
        defaultMessage: 'Retrieving quoted submission...'
    },
    error:{
        id: 'ml.platform.dialog.Error',
        defaultMessage: 'Error'
    },
    qnbPolicyLocked:{
        id: 'ml.platform.dialog.qnbPolicyLocked',
        defaultMessage: 'Your policy is currently locked. Contact us to unlock your policy'
    },
    gatewayPolicyLocked:{
        id: 'ml.platform.dialog.gatewayPolicyLocked',
        defaultMessage: 'This policy is currently locked. Contact Underwriting to unlock policy'
    },
    syncAgentChoice: {
        id: 'ml.platform.dialog.Sync Agent Choice...',
        defaultMessage: 'ml.platform.dialog.Sync Agent Choice...'
    },
    loadingPolicyChange: {
        id: 'ml.platform.dialog.Loading policy change',
        defaultMessage: 'Loading policy change'
    },
    unableToDownloadDocument: {
        id: 'ml.platform.dialog.unableToDownloadDocument',
        defaultMessage: 'We were unable to download your document, please try again.'
    },
    quotingPolicyChange: {
        id: 'ml.platform.dialog.Quoting policy change',
        defaultMessage: 'Quoting policy change'
    },
    savingPolicyChange: {
        id: 'ml.platform.dialog.Saving policy change',
        defaultMessage: 'Saving policy change'
    },
    mlInfoWillBeSavedAsQuoteSubmission: {
        id: 'ml.platform.dialog.The information previously entered will be stored as a quote submission',
        defaultMessage: 'The information previously entered will be stored as a quote submission'
    },
    mlInfoWillNotBeSaved: {
        id: 'ml.platform.dialog.The information you have entered will not be saved',
        defaultMessage: 'The information you have entered will not be saved'
    },
    mlErrorOccurredWarning: {
        id: 'ml.platform.dialog.An error has occurred which may prevent you from completing your quote. If you are unable to continue past this page, please contact customer service for assistance using the chat feature.',
        defaultMessage: 'An error has occurred which may prevent you from completing your quote. If you are unable to continue past this page, please contact customer service for assistance using the chat feature.'
    },
    platformPleaseEnterNumbersOnly: {
        id: 'platform.modelvalidation.DTOValidationService.Please enter numbers only',
        defaultMessage: 'Please enter numbers only'
    },
    platformValueEnteredMustNotContainDecimalValues: {
        id: 'platform.modelvalidation.DTOValidationService.Value entered must not contain decimal values',
        defaultMessage: 'Value entered must not contain decimal values'
    },
    mlInfoSaveAsDraft: {
        id: 'ml.platform.dialog.The information previously entered will be stored as a draft quote submission',
        defaultMessage: 'The information previously entered will be stored as a draft quote submission'
    },
    areYouSureYouWantToCancel: {
        id: 'ml.platform.dialog.Are you sure you want to cancel?',
        defaultMessage: 'Are you sure you want to cancel?'
    },
    areYouSureYouWantToCancelThisPolicyChange: {
        id: 'ml.platform.dialog.Are you sure you want to cancel this policy change?',
        defaultMessage: 'Are you sure you want to cancel this policy change?'
    },
    bindingPolicyChange: {
        id: 'ml.platform.dialog.Binding policy change',
        defaultMessage: 'Binding policy change'
    },
    invalidEmail:{
        id:'ml.common.component.MLCRAdditionalInformationComponent.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    skipEmployerDiscount: {
        id: 'ml.platform.quoteandBind.affiliation.qnbNonServicingStatesSkipDiscount',
        defaultMessage: 'Skip this discount'
    }
});
